import $http from '../../../axios-instance';
import $http_fds from '../../../axios-instance-fds';
import Swal from 'sweetalert2';

/**
 * Parametrizar id de empresa.
 * @param commit
 * @param id_empresa
 * @returns {Promise<void>}
 */
export async function setIdEmpresa({commit}, id_empresa) {
  commit('setIdEmpresa', id_empresa)
}

/**
 * Parametrizar datos de empresa.
 * @param commit
 * @param state
 * @param id_empresa
 * @returns {Promise<void>}
 */
export async function datosFdsEmpresa({commit, state}, id_empresa) {
  commit('dashboard/load', true, {root: true});
  await $http_fds.get(`/fds/datos-empresa/${id_empresa}`)
    .then((response) => {
      commit('dashboard/load', false, {root: true});
      commit('setDatosFdsEmpresa', response.data.data);
      commit('setAccion', 'editar');
      state.error = false;
    })
    .catch((error) => {
      if (error.status == 404) {
        commit('resetSelectedFdsEmpresa', state);
        commit('setAccion', 'crear');
      } else {
        commit('empresaDatosError', error.message);
      }
      commit('dashboard/load', false, {root: true});
    });
}

/**
 * Función para guardar datos de empresa.
 * @param commit
 * @param state
 * @returns {Promise<unknown>}
 */
export async function guardaDatosFdsEmpresa({commit, state}) {
  commit('dashboard/load', true, {root: true});

  return new Promise(async (resolve, reject) => {
    state.selectedFdsEmpresa.id_empresa = state.id_empresa;
    await $http_fds.post('/fds/datos-empresa', state.selectedFdsEmpresa)
      .then((response) => {
        commit('dashboard/load', false, {root: true});
        commit('setDatosFdsEmpresa', response.data.data);
        commit('setAccion', 'editar');
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: response.data.title,
          text: response.data.message,
          showConfirmButton: false,
          timer: 2000
        });
        resolve();
      })
      .catch((error) => {
        commit('dashboard/load', false, {root: true});
          if (this.$vue.$alertErrorsCallback(error)) return;
          this.$vue.$alertError(error.message);
        reject();
      });
  });
}

/**
 * Función para editar datos de empresa.
 * @param commit
 * @param state
 * @returns {Promise<void>}
 */
export async function actualizarDatosFdsEmpresa({commit, state}) {
  commit('dashboard/load', true, {root: true});
  await $http_fds.put(`/fds/datos-empresa`, state.selectedFdsEmpresa)
    .then((response) => {
      commit('dashboard/load', false, {root: true});
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: response.data.title,
        text: response.data.message,
        showConfirmButton: false,
        timer: 2000
      });
      state.error = false;
    })
    .catch((error) => {
      commit('dashboard/load', false, {root: true});
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error.message,
        showConfirmButton: false,
        timer: 2000
      });
    });
}

// fdsEmpresaParametros
/**
 * Obtener listas de parámetros.
 * @param commit
 * @param state
 * @returns {Promise<void>}
 */
export async function getFdsListasParametros({commit, state}) {
  commit('dashboard/load', true, {root: true});
  await $http_fds.get(`/fds/listas-parametros`)
    .then((response) => {
      commit('dashboard/load', false, {root: true});
      commit('setFdsListasParametros', response.data.data);
      state.error = false;
    })
    .catch((error) => {
      commit('empresaParametrosError', error.message);
      commit('dashboard/load', false, {root: true});
    });
}

/**
 * Obtener parámetros de empresas.
 * @param commit
 * @param state
 * @param id_empresa
 * @returns {Promise<void>}
 */
export async function fdsEmpresaParametros({commit, state}, id_empresa) {
  commit('dashboard/load', true, {root: true});
  await $http_fds.get(`/fds/datos-empresa/parametros/${id_empresa}`)
    .then((response) => {
      commit('dashboard/load', false, {root: true});
      commit('setFdsEmpresaParametros', response.data.data);
      commit('setAccion', 'editar');
      state.error = false;
    })
    .catch((error) => {
      if (error.status == 404) {
        commit('resetSelectedFdsEmpresaParametros', state);
        commit('setAccion', 'crear');
      } else {
        commit('empresaParametrosError', error.message);
      }
      commit('dashboard/load', false, {root: true});
    });
}

/**
 * Guardar parámetros de empresa.
 * @param commit
 * @param state
 * @returns {Promise<unknown>}
 */
export async function guardaFdsEmpresaParametros({commit, state}) {
  commit('dashboard/load', true, {root: true});

  return new Promise(async (resolve, reject) => {
    state.selectedFdsEmpresaParametros.id_empresa = state.id_empresa;
    await $http_fds.post('/fds/datos-empresa/parametros', state.selectedFdsEmpresaParametros)
      .then((response) => {
        commit('dashboard/load', false, {root: true});
        commit('setFdsEmpresaParametros', response.data.data);
        commit('setAccion', 'editar');
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: response.data.title,
          text: response.data.message,
          showConfirmButton: false,
          timer: 2000
        });
        resolve();
      })
      .catch((error) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: error.message,
          showConfirmButton: false,
          timer: 2000
        });
        reject();
      });
  });
}

/**
 * Editar parámetros de empresa.
 * @param commit
 * @param state
 * @returns {Promise<void>}
 */
export async function actualizarFdsEmpresaParametros({commit, state}) {
  commit('dashboard/load', true, {root: true});
  await $http_fds.put(`/fds/datos-empresa/parametros`, state.selectedFdsEmpresaParametros)
    .then((response) => {
      commit('dashboard/load', false, {root: true});
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: response.data.title,
        text: response.data.message,
        showConfirmButton: false,
        timer: 2000
      });
      state.error = false;
    })
    .catch((error) => {
      commit('dashboard/load', false, {root: true});
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error.message,
        showConfirmButton: false,
        timer: 2000
      });
    });
}
